/*
 * Cadwork webgl Engine
 * http://www.lexoview.com
 *
 * Copyright (C) 2015 Cadwork Informatik AG, Basel, Switzerland
 * Dual licensed under the MIT and GPL
 *
 * @author Pavel Režňák (reznak@cadwork.cz)
 */

import Layer from "App/render/webgl/layers/layer";
import WebGLRenderGraph from "App/render/webgl/render_graph";
import {Containers} from "App/utils/factory";
import View from "App/view/view";
import {Framebuffer} from "App/utils/frame_buffer";
import Controls from "App/render/webgl/passes/controls";

export default
class ControlsLayer extends Layer {
    constructor(aRenderGraph: WebGLRenderGraph) {
        super(aRenderGraph);

        this._passesID = Containers.PASSES_CONTROLS;
        this._name = 'Controls';
    }

    /**
     * @override
     */
    protected _createFramebuffers() {
        // Framebuffer for all controls
        let scale = 1.0 / this._sceneAPI.renderSettingsModule.getQualityPerformanceFactor();
        let contentSize = this._context.getCanvas().getContentSize();
        let gl = this._context.getWebGLRenderingContext();

        this._framebuffers.add('controls',
            new Framebuffer(this._renderGraph, {
                scale: scale,
                size: [Math.floor(contentSize[0] * scale), Math.floor(contentSize[1] * scale)],
                colorTextureFiltering: gl.NEAREST,
                colorTexturePixelDataType: gl.UNSIGNED_BYTE,
                createColorTexture: true,
                createDepthTexture: false,
                createDepthRenderBuffer: true
            })
        );
    }

    /**
     * @param {View} aView
     * @return {boolean}
     * @override
     */
    public render(aView: View): boolean {

        if (!this.readyToRender()) {
            return true;
        }

        // Render controls and on screen visible objects
        this._passes.get(Controls.TypeName).render(
            aView,
            this._framebuffers.get("controls")
        );

        return true;
    }
}
